import { ProviderTypes } from '../../common/Constants';
import { getLagoonConfigValue } from '../../utils/providerSearch.utils';
import { useLagoon } from '../useLagoon';
import { useSmartChoice } from '../useSmartChoice';

const SMART_CHOICE_ELIGIBLE_PROVIDER_TYPES = [ProviderTypes.PRACTITIONER];

export const useMinProviderCount = (providerType?: string): string => {
  const allConfigs = useLagoon('config');

  const isSmartChoice = useSmartChoice();
  const minProviderCountOthers = getLagoonConfigValue(
    allConfigs,
    'MIN_PROVIDER_COUNT_OTHER'
  );
  const providerCountRecommendation = getLagoonConfigValue(
    allConfigs,
    'MIN_PROVIDER_COUNT_RECOMMENDATION'
  );
  const isEligibleProviderType = SMART_CHOICE_ELIGIBLE_PROVIDER_TYPES.some(
    (eligibleType) => eligibleType.toLowerCase() === providerType?.toLowerCase()
  );
  const minimumProvidersReturn =
    isSmartChoice && isEligibleProviderType
      ? providerCountRecommendation
      : minProviderCountOthers;

  return minimumProvidersReturn?.length > 0 ? minimumProvidersReturn : '';
};
